import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {InBaseFrwComponent} from '../inBaseFrwComponent';

@Component({
  selector: 'cmp-modal-handler',
  template: `<div class="modal-header">
  <h4 class="modal-title" *ngIf="message ">{{ message.title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>{{message.message}}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="closeModal()">Close</button>
</div>
`,
  styles: [``]
})
export class ModalHandlerComponent extends InBaseFrwComponent implements OnInit {

  @Input() message: any;
  @Output() onOk = new EventEmitter();
  @Output() onClose = new EventEmitter();

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit(): void {
  }

  closeModal() {
    this.activeModal.dismiss('Cross click');
  }
}

